import { useState } from "react";
import { motion, AnimatePresence } from "motion/react";
import { CaretDown, CaretUp } from "@phosphor-icons/react";

interface SetupStepsProps {
  steps: string[];
  idPrefix: string;
}

export function SetupSteps({ steps, idPrefix }: SetupStepsProps) {
  const [open, setOpen] = useState(false);
  const panelId = `${idPrefix}-setup-steps-panel`;

  return (
    <div className="mt-3">
      <button
        type="button"
        onClick={() => setOpen((o) => !o)}
        className="flex items-center gap-1 text-[13px] text-foreground cursor-pointer transition-colors"
        aria-expanded={open}
        aria-controls={panelId}
      >
        <span>View setup steps</span>
        {open ? <CaretUp size={14} /> : <CaretDown size={14} />}
      </button>
      <AnimatePresence initial={false}>
        {open && (
          <motion.ol
            id={panelId}
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: "auto", opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            transition={{ duration: 0.2, ease: "easeInOut" }}
            className="mt-2 list-decimal pl-5 text-[13px] text-foreground space-y-1 overflow-hidden"
          >
            {steps.map((step, i) => (
              <li key={i}>{step}</li>
            ))}
          </motion.ol>
        )}
      </AnimatePresence>
    </div>
  );
}
